import { gql } from '@apollo/client';

export const GET_CURRENTLY_PLAYING_AUDIO_UI_STATE = gql`
    query getStatementsUiState {
        uiState @client {
            currentlyPlayingAudio
        }
    }
`;
